import Slider from '@material-ui/core/Slider';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      width: '100%',
      height: '478px',
      marginBottom: '10px',
    },
    containerFilters: {
      width: '250px',
      height: '452px',
    },
    filters: {
      width: '220px',
      height: '385px',
      padding: theme.spacing(2),
      border: '1px solid #f0f0f0',
      backgroundColor: '#fcfcfc',
      borderRadius: '13px',
    },
    filterTitle: {
      fontWeight: 'bold',
      color: theme.palette.primary.main,
      fontSize: '14px',
    },
    filterInput: {
      maxWidth: '65px',
      '&>.MuiInputBase-root': {
        height: '30px',
        width: '65px',
        borderRadius: '17px',
      },
      '&>.MuiInputBase-root>input': {
        textAlign: 'center',
      },
    },
    cars: {
      width: '80%',
      flexGrow:1,
      // maxWidth: '100%',
      height: '528px',
      padding: theme.spacing(2, 0, 2, 2),
      backgroundColor: '#ffff',
      border: '1px solid #fcfcfc',
      borderRadius: '13px',
      boxShadow: '0px 5px 20px #64646433',
      overflow: 'auto',
      overflowX: 'hidden',
      [theme.breakpoints.down(480)]: {
        width: '100%',
        border: 'none',
        boxShadow: 'none',
        padding: '0 6px'
      },
    },
    footerQA: {
      display: 'block',
      color: '#646464',
      margin: '10px 0',
      textAlign: 'justify',
    },
    terms: {
      color: '#c4c4c4',
      fontSize: '14px',
      textAlign: 'justify',
    },
    checkboxRoot: {
      padding: '2px 5px',
      width: '20px',
      height: '20px'
    },
    brandsBox: {
      width: '180px',
      height: '70px',
      padding: '2px',
      marginBottom: '50px',
    },
    checkboxFields: {
      maxWidth: '100%',
      width: '34px',
    },
    ToolTip: {
      width: '100%',
      marginBottom: '12px',
      padding: '14px',
      backgroundColor: '#98C44E1A',
      borderRadius: '13px',
      [theme.breakpoints.down(480)]: {
        width: '170px',
        padding: '6px 14px',
        position: 'absolute',
        borderRadius: '50px',
        backgroundColor: '#E4F4FB',
        top: '-57px',
        right: '10px'
      },
    },
    text: {
      color: '#98C44E',
      fontSize: '16px',
      [theme.breakpoints.down(480)]: {
        fontSize: '12px',
        color: '#00A0DF',
      },
    },
    textActive: {
      color: '#98C44E',
      fontWeight: 'bold',
      fontSize: '16px'
    },
    headerMobile: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center' ,
      marginBottom: '12px',
    },
    titleMobile: {
      color: '#0047BA',
      fontWeight: 'bold',
    },
    buttonFilters: {
      padding: '6px 24px',
      marginRight: '16px',
      backgroundColor: 'transparent',
      borderRadius: '50px',
      border: '1px solid #646464',
      color: '#646464',
      fontWeight: 'bold',
      fontSize: '16px',
    }
  })
);

export const StyledSlider = withStyles({
  root: {
    color: '#0047BA',
    height: '8px',
    maxWidth: '150px',
  },
  track: {
    height: '6px',
    borderRadius: '4px',
    maxWidth: '150px',
  },
  rail: {
    height: '6px',
    borderRadius: '4px',
    maxWidth: '150px',
  },
  thumb: {
    height: '15px',
    width: '15px',
  },
})(Slider);

export default useStyles;
